function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#98ABC7",
  fillRule: "nonzero",
  d: "M0.36 16.04C0.06 16.32 -0.07 16.75 0.03 17.15C0.12 17.55 0.43 17.86 0.82 17.97C1.22 18.07 1.63 17.94 1.9 17.63C2.66 16.85 8.78 10.56 9.54 9.77C9.62 9.7 9.69 9.61 9.73 9.51C9.73 9.48 9.77 9.45 9.79 9.41C9.79 9.4 9.82 9.31 9.82 9.3C9.82 9.26 9.82 9.23 9.82 9.2C9.85 9.05 9.85 8.9 9.82 8.76C9.82 8.72 9.82 8.69 9.82 8.66C9.82 8.65 9.79 8.56 9.79 8.55C9.79 8.51 9.75 8.48 9.73 8.44C9.72 8.41 9.7 8.38 9.68 8.36C9.64 8.3 9.6 8.24 9.55 8.19C8.79 7.4 2.67 1.12 1.9 0.33C1.49 -0.1 0.82 -0.11 0.39 0.3C0.38 0.31 0.37 0.32 0.36 0.33C-0.07 0.77 -0.07 1.47 0.36 1.92C0.94 2.51 5.56 7.26 6.14 7.86C6.53 8.26 6.72 8.6 6.72 8.87C6.72 9.15 6.53 9.56 6.14 10.1C6.14 10.1 0.94 15.45 0.36 16.04Z"
});

function SvgChevronRight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 18,
    viewBox: "0 0 10 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronRight);
export default __webpack_public_path__ + "static/media/chevron-right.87e9ed52.svg";
export { ForwardRef as ReactComponent };